import { HttpErrorResponse } from "@angular/common/http";
import { createAction, props } from "@ngrx/store";
import { Centre, AddCentreDto, UpdateCentreTableDto, CentreListDTO } from "src/app/_models/Centre";
import { CentreActionTypes } from "src/app/constants/StoreConstants";

export const CheckIsValidCentreName = createAction(
    CentreActionTypes.CheckIsValidCentreName,
    props<{centreId: number, centreName: string, orgId: number}>()
);

export const CheckIsValidCentreNameSuccess = createAction(
    CentreActionTypes.CheckIsValidCentreNameSuccess,
    props<{result: boolean}>()
);

export const CheckIsValidCentreNameError = createAction(
    CentreActionTypes.CheckIsValidCentreNameError,
    props<{error: any}>()
);

export const SetCentreData = createAction(
    CentreActionTypes.SetCentreData,
    props<{centre: CentreListDTO}>()
);

export const SetCentreDataSuccess = createAction(
    CentreActionTypes.SetCentreDataSuccess
);

export const AddCentre = createAction(
    CentreActionTypes.AddCentre,
    props<{addCentreDto: AddCentreDto}>()
);

export const AddCentreSuccess = createAction(
    CentreActionTypes.AddCentreSuccess,
    props<{result: Centre}>()
);

export const AddCentreError = createAction(
    CentreActionTypes.AddCentreError,
    props<{error: any}>()
);

export const UpdateCentre = createAction(
    CentreActionTypes.UpdateCentre,
    props<{centre: Centre}>()
);

export const UpdateCentreSuccess = createAction(
    CentreActionTypes.UpdateCentreSuccess,
    props<{centre: Centre}>()
);

export const UpdateCentreError = createAction(
    CentreActionTypes.UpdateCentreError,
    props<{error: any}>()
);

export const ClearCentreState = createAction(
    CentreActionTypes.ClearCentreState
);

export const ClearCrudCentreState = createAction(
    CentreActionTypes.ClearCrudCentreState
);

export const UpdateCentreTable = createAction(
    CentreActionTypes.UpdateCentreTable,
    props<{updateCentreTableDto: UpdateCentreTableDto, isGetlength: boolean}>()
);

export const UpdateCentreTableSuccess = createAction(
    CentreActionTypes.UpdateCentreTableSuccess,
    props<{result: boolean}>()
);

export const UpdateCentreTableError = createAction(
    CentreActionTypes.UpdateCentreTableError,
    props<{error: any}>()
);

export const GetCentreTable = createAction(
    CentreActionTypes.GetCentreTable,
    props<{pageIndex: number, isInitialLoad: boolean, isGetLength: boolean}>()
);

export const GetCentreTableSuccess = createAction(
    CentreActionTypes.GetCentreTableSuccess,
    props<{result: CentreListDTO[], isGetLength: boolean}>()
);

export const GetCentreTableError = createAction(
    CentreActionTypes.GetCentreTableError,
    props<{error: any}>()
);

export const GetCentreTableLength = createAction(
    CentreActionTypes.GetCentreTableLength
);

export const GetCentreTableLengthSuccess = createAction(
    CentreActionTypes.GetCentreTableLengthSuccess,
    props<{result: number}>()
);

export const GetCentreTableLengthError = createAction(
    CentreActionTypes.GetCentreTableLengthError,
    props<{error: any}>()
);

export const GetCentresByOrgId = createAction(
    CentreActionTypes.GetCentresByOrgId,
    props<{orgId: number}>()
);

export const GetCentresByOrgIdSuccess = createAction(
    CentreActionTypes.GetCentresByOrgIdSuccess,
    props<{result: Centre[]}>()
);

export const GetCentresByOrgIdError = createAction(
    CentreActionTypes.GetCentresByOrgIdError,
    props<{error: any}>()
);

export const GetCentresByUserIdAndOrgId = createAction(
    CentreActionTypes.GetCentresByUserIdAndOrgId,
    props<{userId: number, orgId: number}>()
);

export const GetCentresByUserIdAndOrgIdSuccess = createAction(
    CentreActionTypes.GetCentresByUserIdAndOrgIdSuccess,
    props<{result: Centre[]}>()
);

export const GetCentresByUserIdAndOrgIdError = createAction(
    CentreActionTypes.GetCentresByUserIdAndOrgIdError,
    props<{error: any}>()
);

export const ResetCentresByOrgIdList = createAction(
    CentreActionTypes.ResetCentresByOrgIdList
);

export const ResetCentreTable = createAction(
    CentreActionTypes.ResetCentreTable,
    props<{isInitialLoad: boolean}>()
);

export const ResetCentreTableSuccess = createAction(
    CentreActionTypes.ResetCentreTableSuccess,
    props<{isInitialLoad: boolean}>()
);

export const ResetCentreTableError = createAction(
    CentreActionTypes.ResetCentreTableError,
    props<{error: any}>()
);

export const ResetCentreTableUnload = createAction(
    CentreActionTypes.ResetCentreTable
);

export const GetAllCentre = createAction(
    CentreActionTypes.GetAllCentre
);

export const GetAllCentreSuccess = createAction(
    CentreActionTypes.GetAllCentreSuccess,
    props<{result: Centre[]}>()
);

export const GetAllCentreError = createAction(
    CentreActionTypes.GetAllCentreError,
    props<{error: any}>()
);

export const ValidateDeleteCentre = createAction(
    CentreActionTypes.ValidateDeleteCentre,
    props<{ id: number }>()
);

export const ValidateDeleteCentreSuccess = createAction(
    CentreActionTypes.ValidateDeleteCentreSuccess,
    props<{ isValid: boolean }>()
);

export const ValidateDeleteCentreError = createAction(
    CentreActionTypes.ValidateDeleteCentreError,
    props<{ error: any }>()
);

export const DeleteCentre = createAction(
    CentreActionTypes.DeleteCentre,
    props<{ id: number }>()
);

export const DeleteCentreSuccess = createAction(
    CentreActionTypes.DeleteCentreSuccess,
    props<{ isDeletedSuccessFully: boolean }>()
);

export const DeleteCentreError = createAction(
    CentreActionTypes.DeleteCentreError,
    props<{ error: any }>()
);

export const ResetDeleteCentre = createAction(
    CentreActionTypes.ResetDeleteCentre
);

export const GetAllCentresByOrgIds = createAction(
    CentreActionTypes.GetAllCentresByOrgIds,
    props<{orgIds: number[]}>()
);

export const GetAllCentresByOrgIdsSuccess = createAction(
    CentreActionTypes.GetAllCentresByOrgIdsSuccess,
    props<{result: Centre[]}>()
);

export const GetAllCentresByOrgIdsError = createAction(
    CentreActionTypes.GetAllCentresByOrgIdsError,
    props<{error: HttpErrorResponse}>()
);

export const GetAllCentresByOrgIdsTutorFlow = createAction(
    CentreActionTypes.GetAllCentresByOrgIdsTutorFlow,
    props<{orgIds: number[]}>()
);

export const GetAllCentresByOrgIdsTutorFlowSuccess = createAction(
    CentreActionTypes.GetAllCentresByOrgIdsTutorFlowSuccess,
    props<{result: Centre[]}>()
);

export const GetAllCentresByOrgIdsTutorFlowError = createAction(
    CentreActionTypes.GetAllCentresByOrgIdsTutorFlowError,
    props<{error: HttpErrorResponse}>()
);

export const ResetAllCentresByOrgIds = createAction(
    CentreActionTypes.ResetAllCentresByOrgIds
);
